import { async, types } from '~/utils/typeCreator'

export default types(
  [...async('STATS'), 'CLEAR_STATE'],
  'NOTICE_MANAGEMENT_DASHBOARD'
)
